/* eslint-disable @typescript-eslint/dot-notation */
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { GroupService } from 'src/app/services/group.service';

@Component({
  selector: 'app-select-group',
  templateUrl: './select-group.component.html',
  styleUrls: ['./select-group.component.scss'],
})
export class SelectGroupComponent implements OnInit {
  @Input() public joined: any;
  currentUser = this.authService.currentUser;
  groups = [];
  isLoaded;
  constructor(
    public navController: NavController,
    public modalController: ModalController,
    public groupService: GroupService,
    public authService: AuthService,

  ) {
    this.groupService.getUserGroups(this.currentUser.id).then((groups: any) => {
      groups.forEach(group => {
        this.groups.push(group);
      });
      this.isLoaded = true;
    });
  }

  ngOnInit() {
  }

  selectGroup(id) {
    this.modalController.dismiss(id);
  }

  ionViewDidEnter() {

  }


  closeModal() {
    this.modalController.dismiss();
  }

}
